import checkValid from "../../../../helpers/validation/inputValidate";
import {COMMON_NAMESPACE} from "../../../../utils/i18nNameSpaces";

export const INPUT_NAME = "name";
export const INPUT_PHONE = "phone";
export const INPUT_EMAIL = "email";
export const INPUT_STACK = "stack";
export const INPUT_COMMENT = "comment";
export const INPUT_AGREE = "agree";
export const INPUT_CV = "cv";

export const initialInputs = (t) => ({
  [INPUT_NAME]: {
    name: INPUT_NAME,
    value: "",
    shouldValidate: true,
    isValid: true,
    setValue: function (outValue) {
      this.value = outValue
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },

  [INPUT_PHONE]: {
    name: INPUT_PHONE,
    value: "",
    shouldValidate: true,
    isValid: true,
    setValue: function (outValue) {
      this.value = outValue
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },
  [INPUT_EMAIL]: {
    name: INPUT_EMAIL,
    value: "",
    shouldValidate: true,
    isValid: true,
    setValue: function (outValue) {
      this.value = outValue
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },
  [INPUT_STACK]: {
    name: INPUT_STACK,
    value: "",
    isValid: true,
    shouldValidate: false,
    setValue: function (outValue) {
      this.value = outValue
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },
  [INPUT_CV]: {
    name: INPUT_CV,
    value: "",
    isValid: true,
    shouldValidate: false,
    setValue: function (outValue) {
      this.value = outValue;
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },
  [INPUT_AGREE]: {
    name: INPUT_AGREE,
    value: true,
    isValid: true,
    shouldValidate: true,
    setValue: function (outValue) {
      this.value = outValue
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },
  [INPUT_COMMENT]: {
    name: INPUT_COMMENT,
    value: "",
    shouldValidate: false,
    isValid: true,
    setValue: function (outValue) {
      this.value = outValue
    },
    validate: function () {
      return checkValid(this, t)
    },
    error: t(`${COMMON_NAMESPACE}:error.empty`),
    uniqueError: null
  },
})
